import React, { createContext, useContext } from 'react';

export const TABS = {
  APP_REVIEW: 'app-review',
  REDISCOVERY: 'rediscovery',
  MY_GREENHOUSE: 'mygreenhouse',
} as const;

export type TabKey = typeof TABS[keyof typeof TABS];

export interface UserContextValue {
  calibrationTerms: string[];
  canCreateTags: boolean;
  canExport: boolean;
  canUseLocations: boolean;
  isSiteAdmin: boolean;
  userDateFormat: string;
  linkedinRscEnabled: boolean;
  canUseSecurityConcerns: boolean;
  userId: number;
  hiringPlanId: number;
  activeTab: TabKey;
}

export const UserContext = createContext<UserContextValue | undefined>(
  undefined
);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext not used within a UserContext.Provider');
  }
  return context;
};

export type UserContextProviderProps = {
  value: UserContextValue;
  children: React.ReactNode;
};

export const UserContextProvider = ({
  value,
  children,
}: UserContextProviderProps) => {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
